import React from "react";
import { Box } from "../../../shared/components/ui/chakra";

import { HStack } from "@chakra-ui/react";
import DiamondIcon from "../../../shared/components/icons/DiamondIcon";
import LockOpenIcon from "../../../shared/components/icons/LockOpenIcon";
import { SharedStudyGroup } from "../../../shared/lib/types";

const VisibilityScope = ({
  studyGroup,
}: {
  studyGroup: Pick<SharedStudyGroup, "visibility_scope">;
}) => {
  return studyGroup.visibility_scope === "approved_user" ? (
    <HStack
      px={3}
      py={1.5}
      borderTopRadius={12}
      borderBottomRadius={2}
      bgColor="brand.100"
      w="fit-content"
      gap={1}
    >
      <DiamondIcon />
      <Box color="brand.700" fontSize="xs" fontWeight="bold">
        会員様限定動画
      </Box>
    </HStack>
  ) : (
    <HStack
      px={3}
      py={1.5}
      borderTopRadius={12}
      borderBottomRadius={2}
      bgColor="#F5EDD7"
      w="fit-content"
      gap={1}
    >
      <LockOpenIcon />
      <Box color="#735301" fontSize="xs" fontWeight="bold">
        誰でも閲覧可能
      </Box>
    </HStack>
  );
};

export default VisibilityScope
